"use client"

import React from 'react';
import './Switch.css';

const Switch = ({ isSelected, onChange, children }) => {
  return (
    <label className="switch-label">
      <div className={`switch ${isSelected ? 'selected' : ''}`} onClick={() => onChange(!isSelected)}>
        <div className="switch-thumb" />
      </div>
      {children}
    </label>
  );
};

export { Switch }; 